module.exports = __webpack_public_path__ + "img/main-logo.29627eef.png";